export { default as Home } from './Home/Home';
export { default as SignIn } from './SignIn/SignIn';
export { default as ProtectedRoute } from './Root';

export { default as OrderPage } from './ManageOrder/OrderPage/OrderPage';

export { default as ContractPage } from './ManageOrder/ContractPage/ContractPage';
export { default as OrderReportPage } from './Report/OrderReport/OrderReport';
export { default as ProductReportPage } from './Report/ProductReport/ProductReport';
export { default as CustomerReportPage } from './Report/CustomerReport/CustomerReport';

export { default as UserPage } from './System/UserPage/UserPage';
export { default as FilterUserPage } from './System/UserPage/FilterUserPage';
export { default as TableUserPage } from './System/UserPage/TableUserPage';
export { default as ModalEditUser } from './System/UserPage/ModalEditUser';

export { default as ProfilePage } from './Profile/ProfilePage';

export { default as SaleLinePage } from './Plant/SaleLine/SaleLinePage';
export { default as FilterSaleLinePage } from './Plant/SaleLine/FilterSaleLinePage';
export { default as TableSaleLinePage } from './Plant/SaleLine/TableSaleLinePage';
export { default as DrawerSaleLinePage } from './Plant/SaleLine/DrawerSaleLinePage';

export { default as SaleTeamPage } from './Plant/SaleTeamPage/SaleTeamPage';
export { default as FilterSaleTeamPage } from './Plant/SaleTeamPage/FilterSaleTeamPage';
export { default as TableSaleTeamPage } from './Plant/SaleTeamPage/TableSaleTeamPage';

export { default as CustomerPage } from './Plant/Customer/CustomerPage';

export { default as HOPlan } from './Plant/HOPlan/HOPlan';

export { default as CNPlan } from './Plant/CNPlan/CNPlan';

export { default as SaleLineTeam } from './Plant/SaleLineTeam/SaleLineTeam';
export { default as TerroristList } from './Terrorist/TerroristList';
export { default as TerroristVerification } from './Terrorist/TerroristVerification';
